import { ENV } from "shared-tsi";
import { environmentBase } from "./environment.base";

export const environment = {
    ...environmentBase,
    production: false,
    name: ENV.DEV,
    apiService_Ecommerce:'/backend-ecommerce',
    apiService_Auth: '/backend-login',
    apiService_Erp: '/backend-api',
    apiService_Report: '/backend-report',
    recaptcha: {
        siteKey: '6LdqZT0sAAAAAHAFBX8eo0fXQKCHYhd9C6IoY7UZ',
    }
}